import React from 'react';
import './RecordingSelector.css';

function RecordingSelector({ recordings, selectedRecording, onSelectRecording }) {
  const formatDateTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="recording-selector">
      <label htmlFor="recording-dropdown">
        <span className="label-icon">🎥</span>
        Select Recording
      </label>
      <select
        id="recording-dropdown"
        value={selectedRecording || ''}
        onChange={(e) => onSelectRecording(e.target.value)}
      >
        {recordings.map((recording) => (
          <option key={recording.id} value={recording.id}>
            {recording.spaceName} - {formatDateTime(recording.startingTime)} ({recording.count} moments)
          </option>
        ))}
      </select>
    </div>
  );
}

export default RecordingSelector;
